import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { useEffect, useState } from 'react';
import { IMedicalServiceEtlField } from '../types';
import { medicalServiceEtlFieldService } from '../api/medical-service-etl-field.service';

interface MedicalServiceEtlFieldFormProps {
  transcode: IMedicalServiceEtlField;
  onSubmit: any;
}

export interface FieldChoice {
  code: string;
  description: string;
}

function MedicalServiceEtlFieldForm({ transcode, onSubmit }: MedicalServiceEtlFieldFormProps) {
  const { t } = useTranslation();
  const [fields_choices, setFields_choices] = useState([]);
  useEffect(() => {
    medicalServiceEtlFieldService.getChoices().then((res) => {
      setFields_choices(
        res.data.reduce((acc, curr) => {
          acc.push({ code: curr[0], description: curr[1] });
          return acc;
        }, [])
      );
    });
  }, []);

  return (
    <>
      {transcode && (
        <EnhancedForm onSubmit={onSubmit} edit={!!transcode.id} autoStyleLayout columns={3}>
          <IdentityField
            name="field_to"
            component={AutocompleteAdapter}
            label={t('global.field_to')}
            options={fields_choices}
            optionValue="code"
            optionLabel="description"
            type="text"
            required
            submitObject
          />

          <IdentityField
            name="field_from"
            component={TextFieldAdapter}
            label={t('global.field_from')}
            type="text"
            required
          />

          <IdentityField
            name="transcode"
            component={TextFieldAdapter}
            label={t('global.transcode')}
            placeholder={t('global.transcode')}
            type="text"
          />
        </EnhancedForm>
      )}
    </>
  );
}

export default MedicalServiceEtlFieldForm;
